import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import LoginForm from "../../components/Login/LoginForm";
import "../../components/Login/login.css";
import MessageNoProvider from "../../components/UI/MessageNoProvider/MessageNoProvider";


const Login = () => {
  const navigate = useNavigate();
  const userDate = localStorage.getItem("deskbooking");
  const objUserDate = JSON.parse(userDate);
  const authConfiguration = useSelector(
    (state) => state.configurations.configurazioniAutenticazione
  );

  useEffect(() => {
    if (objUserDate != null && Object.entries(objUserDate).length !== 0) {
      navigate("/prenotazioni");
    }
  }, [objUserDate, navigate]);

  if (objUserDate != null && Object.entries(objUserDate).length !== 0) {
    return null; // Per evitare di renderizzare il resto del componente 
  }

  return (
    <>
      {authConfiguration && Object.keys(authConfiguration).length > 0 && (
        <>
          {authConfiguration?.enableActiveDirectoryAuth ||
          authConfiguration?.enableDatabaseAuth ? (
            <LoginForm />
          ) : (
            <MessageNoProvider />
          )}
        </>
      )}
    </>
  );
};

export default Login;
